<script setup>
import { ref, toRefs, onMounted, onUnmounted } from "vue";
import MainAutoMessage from "/src/components/molecules/MainAutoMessageCf.vue";
import BuyGoods from "/src/components/molecules/BuyGoodscf.vue";
import VideoPlayerArchive from "/src/components/molecules/VideoPlayerArchive.vue";
import MainCommnetInput from "/src/components/molecules/MainCommnetInputCf.vue";
import CrowdfundingAnimationHeart from "/src/components/molecules/CrowdfundingAnimationHeart.vue";
import "video.js/dist/video-js.css";
import { useRouter } from "vue-router";
import MainVendorInfo from "../molecules/MainVendorInfo.vue";
import CrowdfundingProgressBar from "../molecules/CrowdfundingProgressBar.vue";
const props = defineProps({
  showmessage: Array,
  videourl: String,
  videourlforondemand: String,
  addresses: Array,
  cardsInfo: Array,
  goodsData: Array,
  orderId: String,
  error: String,
  isLoadingforcredit: Boolean,
  shippingFee: Number,
  totallPrice: Number,
  sumPrice: Number,
  vendorsData: String,
  defaultAddress: String,
  defaultCard: String,
  defaultpaymentmethod: String,
  goods_dialogaftercarrier: Boolean,
  user: Object,
  vendorname_ja: String,
  currentAmount: Number,
  targetAmount: Number,
  campaignId: String, // クラウドファンディング用：プロジェクトID
  MessageTime: Object, // ライブ開始時刻（Timestamp）
  isArchive: {
    type: Boolean,
    default: false,
  }, // アーカイブモードかどうか
  crowdfundingSupportResult: Object, // クラウドファンディング用：支援結果
});
const emit = defineEmits([
  "chooseGoods",
  "comfirmGoods",
  "commentinput",
  "sendaddress",
  "getAddressData",
  "shippingfeeandorderprice",
  "comfirmGoodsforcarrierpayment",
  "comfirmGoodsforpaidy",
  "comfirmCrowdfundingSupport", // クラウドファンディング用：支援確定
  "crowdfundingSupportResult", // クラウドファンディング用：支援結果通知
]);

const { videourl } = toRefs(props);
const { videourlforondemand } = toRefs(props);
const { goods_dialogaftercarrier } = toRefs(props);
//以下親へ渡す
const chooseGoods = (selectnumber) => {
  emit("chooseGoods", selectnumber);
};

// iPhoneかどうかを判定
const isIPhone = ref(false);
const checkIsIPhone = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  // iPhoneを検出（iPadは除外）
  isIPhone.value = /iphone/.test(userAgent) && !/ipad/.test(userAgent) && !/ipod/.test(userAgent);
};

const isMuted = ref(true);
const toggleMute = () => {
  isMuted.value = !isMuted.value; // 現在の値を反転させる
};

// 音声モードの状態管理
const isAudioMode = ref(false);
const toggleAudioMode = () => {
  isAudioMode.value = !isAudioMode.value;
};

const goods_dialog = ref(false);
const goodsClose = () => {
  goods_dialog.value = false;
};
const comfirmGoods = (selectnumber, choosebuycard, chooseaddress, cardId) => {
  emit("comfirmGoods", selectnumber, choosebuycard, chooseaddress, cardId);
};
const comfirmGoodsforcarrierpayment = (selectnumber, choosebuycard, chooseaddress, cardId) => {
  emit("comfirmGoodsforcarrierpayment", selectnumber, choosebuycard, chooseaddress, cardId);
};
const comfirmGoodsforpaidy = (selectnumber, chooseaddress, paidyPaymentId) => {
  emit("comfirmGoodsforpaidy", selectnumber, chooseaddress, paidyPaymentId);
};

// クラウドファンディング用：支援確定
const comfirmCrowdfundingSupport = async (supportData) => {
  // 親コンポーネントの処理を待つ
  const result = await emit("comfirmCrowdfundingSupport", supportData);
  // 結果を子コンポーネントに通知
  emit("crowdfundingSupportResult", result);
  return result;
};

const sendaddress = (postcode, address1, address2, name, phoneno) => {
  emit("sendaddress", postcode, address1, address2, name, phoneno);
};

const commentinput = (commenttext) => {
  emit("commentinput", commenttext);
};

const getAddressData = () => {
  emit("getAddressData");
};

const getCreditCard = () => {
  emit("getCreditCard");
};
const shippingfeeandorderprice = () => {
  emit("shippingfeeandorderprice");
};

const router = useRouter();
const backToHome = () => {
  router.push("/");
};

//画面出し分け
// リアクティブな変数を作成
const isPc = ref(false);

// メディアクエリのマッチ時の処理
function updateMatch(e) {
  isPc.value = e.matches;
}

// メディアクエリを保持
let mediaQuery = null;

onMounted(() => {
  if (goods_dialogaftercarrier.value == true) {
    goods_dialog.value = true;
  }
  // iPhoneかどうかを判定
  checkIsIPhone();

  // メディアクエリの設定
  mediaQuery = window.matchMedia("(min-width: 960px)");
  mediaQuery.addEventListener("change", updateMatch);
  // 初期値のセット
  updateMatch(mediaQuery);
});

onUnmounted(() => {
  // コンポーネントの破棄時にリスナーを削除
  if (mediaQuery) {
    mediaQuery.removeEventListener("change", updateMatch);
  }
});
const handleClickGacha = () => {
  goods_dialog.value = true;
};

//ビデオ再生経過時間を子のVideoPlayerArchive.vueから受け取る
const currentVideoTime = ref(0); // ビデオの再生経過時間を保持

const handleTimeUpdate = (time) => {
  currentVideoTime.value = time.value; // 再生経過時間を更新
};
</script>

<template>
  <!-- PCの場合-->
  <div v-if="isPc">
    <div class="pc_container">
      <!-- 動画 -->
      <div class="pc_movie_area">
        <VideoPlayerArchive
          :videourl="videourl"
          :videourlforondemand="videourlforondemand"
          :isMuted="isMuted"
          :isAudioMode="isAudioMode"
          :isArchive="isArchive"
          @timeupdate="handleTimeUpdate"
        />
      </div>
      <!-- 情報エリア -->
      <div class="pc_info_area">
        <div class="pc_info_area_inner">
          <div class="btn_sound">
            <!-- 音ボタンの挙動-->
            <img v-if="isMuted" @click="toggleMute()" src="/img/soundoff.png" />
            <img v-if="!isMuted" @click="toggleMute()" src="/img/soundon.png" />
          </div>
          <!-- header -->
          <div class="pc_header">
            <div class="pc_head_inner">
              <!-- 配信者・配信情報 -->
              <MainVendorInfo :vendorsData="vendorsData" />
              <!-- 進捗バー -->
              <CrowdfundingProgressBar
                :currentAmount="currentAmount"
                :targetAmount="targetAmount"
              />
              <!-- 進捗バー END -->
            </div>
          </div>
          <!-- header END -->
          <!-- コメント掲載エリア -->
          <div class="pc_comment_list">
            <div class="pc_comment_list_inner">
              <MainAutoMessage
                :showmessage="showmessage"
                :currentVideoTime="currentVideoTime"
                :MessageTime="MessageTime"
              />
            </div>
          </div>
          <!-- コメント掲載エリア -->
          <!-- footer -->
          <div class="pc_footer">
            <div class="pc_footer_inner">
              <!-- コメントエリア -->
              <div class="pc_comment_area" v-if="!isArchive">
                <MainCommnetInput @commentinput="commentinput" />
              </div>
              <!-- コメントエリア END -->
              <!-- アイテムエリア -->

              <div class="item_list">
                <ul>
                  <!-- ハート-->
                  <CrowdfundingAnimationHeart v-if="!isArchive" />

                  <!-- グッズガチャ -->
                  <li v-if="!isArchive">
                    <img
                      class="btngacha"
                      @click="handleClickGacha"
                      src="/img/crowdfundingpic/shien.webp"
                    />
                  </li>
                  <BuyGoods
                    v-if="!isArchive"
                    :goods_dialog="goods_dialog"
                    :addresses="addresses"
                    :cardsInfo="cardsInfo"
                    :goodsData="goodsData"
                    :orderId="orderId"
                    :error="error"
                    :isLoadingforcredit="isLoadingforcredit"
                    :shippingFee="shippingFee"
                    :totallPrice="totallPrice"
                    :sumPrice="sumPrice"
                    :defaultAddress="defaultAddress"
                    :defaultCard="defaultCard"
                    :defaultpaymentmethod="defaultpaymentmethod"
                    :goods_dialogaftercarrier="goods_dialogaftercarrier"
                    :campaignId="campaignId"
                    :crowdfundingSupportResult="crowdfundingSupportResult"
                    @goodsclose="goodsClose"
                    @chooseGoods="chooseGoods"
                    @comfirmGoods="comfirmGoods"
                    @sendaddress="sendaddress"
                    @getAddressData="getAddressData"
                    @getCreditCard="getCreditCard"
                    @shippingfeeandorderprice="shippingfeeandorderprice"
                    @comfirmGoodsforcarrierpayment="comfirmGoodsforcarrierpayment"
                    @comfirmGoodsforpaidy="comfirmGoodsforpaidy"
                    @comfirmCrowdfundingSupport="comfirmCrowdfundingSupport"
                    :user="user"
                    :vendorname_ja="vendorname_ja"
                  />
                </ul>
              </div>
              <!-- アイテムエリア END -->
            </div>
          </div>
          <!-- footer END -->
        </div>
      </div>
    </div>
  </div>

  <!-- スマホの場合-->
  <div v-else class="container">
    <div class="btn_close">
      <!-- 閉じるボタンの挙動-->
      <img @click="backToHome()" src="/img/btn_close.png" />
    </div>
    <div class="btn_sound">
      <!-- 音ボタンの挙動-->
      <img v-if="isMuted" @click="toggleMute()" src="/img/soundoff.png" />
      <img v-if="!isMuted" @click="toggleMute()" src="/img/soundon.png" />
    </div>
    <!-- 音声モードボタン（iPhone向け） -->
    <div class="btn_audio_mode" v-if="!isPc && isIPhone" @click="toggleAudioMode()">
      <svg
        v-if="!isAudioMode"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="white"
        style="filter: drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.5))"
      >
        <path
          d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
        />
      </svg>
      <svg
        v-if="isAudioMode"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="#4CAF50"
        style="filter: drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.5))"
      >
        <path
          d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
        />
      </svg>
    </div>
    <!-- 動画 -->
    <VideoPlayerArchive
      :videourl="videourl"
      :videourlforondemand="videourlforondemand"
      :isMuted="isMuted"
      :isAudioMode="isAudioMode"
      :isArchive="isArchive"
      @timeupdate="handleTimeUpdate"
    />
    <!-- header -->
    <div class="header">
      <div class="head_inner">
        <!-- 配信者・配信情報 -->
        <MainVendorInfo :vendorsData="vendorsData" />
        <!-- 進捗バー -->
        <CrowdfundingProgressBar :currentAmount="currentAmount" :targetAmount="targetAmount" />
        <!-- 進捗バー END -->
        <!-- 配信者・配信情報 END -->
      </div>
    </div>
    <!-- header END -->

    <!-- コメント掲載エリア -->
    <div class="comment_list">
      <div class="comment_list_inner">
        <MainAutoMessage
          :showmessage="showmessage"
          :currentVideoTime="currentVideoTime"
          :MessageTime="MessageTime"
        />
      </div>
    </div>
    <!-- コメント掲載エリア -->

    <!-- footer -->
    <div class="footer">
      <div class="footer_inner">
        <!-- コメントエリア -->
        <div class="comment_area" v-if="!isArchive">
          <MainCommnetInput @commentinput="commentinput" />
        </div>
        <!-- コメントエリア END -->
        <!-- アイテムエリア -->

        <div class="item_list">
          <ul>
            <!-- ハート-->
            <CrowdfundingAnimationHeart v-if="!isArchive" />

            <!-- グッズガチャ -->
            <li v-if="!isArchive">
              <img
                class="btngacha"
                @click="handleClickGacha"
                src="/img/crowdfundingpic/shien.webp"
              />
            </li>
            <BuyGoods
              v-if="!isArchive"
              :goods_dialog="goods_dialog"
              :addresses="addresses"
              :cardsInfo="cardsInfo"
              :goodsData="goodsData"
              :orderId="orderId"
              :error="error"
              :isLoadingforcredit="isLoadingforcredit"
              :shippingFee="shippingFee"
              :totallPrice="totallPrice"
              :sumPrice="sumPrice"
              :defaultAddress="defaultAddress"
              :defaultCard="defaultCard"
              :defaultpaymentmethod="defaultpaymentmethod"
              :goods_dialogaftercarrier="goods_dialogaftercarrier"
              :campaignId="campaignId"
              :crowdfundingSupportResult="crowdfundingSupportResult"
              @goodsclose="goodsClose"
              @chooseGoods="chooseGoods"
              @comfirmGoods="comfirmGoods"
              @sendaddress="sendaddress"
              @getAddressData="getAddressData"
              @getCreditCard="getCreditCard"
              @shippingfeeandorderprice="shippingfeeandorderprice"
              @comfirmGoodsforcarrierpayment="comfirmGoodsforcarrierpayment"
              @comfirmGoodsforpaidy="comfirmGoodsforpaidy"
              @comfirmCrowdfundingSupport="comfirmCrowdfundingSupport"
              :user="user"
              :vendorname_ja="vendorname_ja"
            />
          </ul>
        </div>
        <!-- アイテムエリア END -->
      </div>
    </div>
    <!-- footer END -->
  </div>
  <!-- container END -->
</template>

<style scoped>
.container {
  height: 100%;
  background-color: #333;
  touch-action: manipulation; /* モバイルでの拡大を禁止 */
  zoom: 1; /* ブラウザでの拡大を禁止 */
}

.btn_close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  z-index: 1000;
  cursor: pointer;
  filter: drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.5));
}
.btn_close img {
  width: 100%;
}
.btn_sound {
  position: absolute;
  top: 150px;
  right: 17px;
  width: 40px;
  height: 40px;
  z-index: 1000;
  cursor: pointer;
  background-color: #3b3b3b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.btn_sound img {
  width: 100%;
  filter: drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.5));
}
.btn_audio_mode {
  position: absolute;
  top: 200px;
  right: 17px;
  width: 40px;
  height: 40px;
  z-index: 1000;
  cursor: pointer;
  background-color: #3b3b3b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.btn_audio_mode img {
  width: 100%;
}

/* ヘッダー ---------------------------------------------  */
.header {
  position: absolute;
  top: 15px;
  width: 100%;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.05);
}
.header::before {
  content: "";
  position: absolute;
  top: -15px;
  left: 0;
  width: 100%;
  height: 15px;
  background-color: rgba(0, 0, 0, 0.05);
  pointer-events: none;
  z-index: -1;
}
.header .pc_head_inner {
  margin-left: 12px;
  margin-right: 12px;
}

/* ヘッダー END --------------------------------------------- */

/* コメント */
.comment_list {
  width: 100%;
  height: 200px;
  position: absolute;
  bottom: 50px;
  overflow: scroll;
  z-index: 3;
}
.comment_list .comment_list_inner {
  margin-left: 12px;
  margin-right: 12px;
}
/* コメント END */

/* footer --------------------------------------------- */
.footer {
  width: 100%;
  height: 40px;
  position: absolute;
  bottom: 5px;
  z-index: 1;
}
.footer .footer_inner {
  margin-left: 12px;
  margin-right: 12px;
}
.footer_inner {
  display: flex;
  flex-wrap: no-wrap;
  justify-content: space-between;
}
.comment_area {
  width: calc(100% - 100px);
}
.comment_area .comment:focus {
  border: 0;
}
.item_list {
  z-index: 1;
}
.item_list ul {
  display: flex;
  flex-wrap: no-wrap;
}
.item_list ul li {
  width: 40px;
  margin-left: 10px;
}
.item_list ul li img {
  width: 100%;
  position: relative;
  z-index: 2;
}

/* footer END --------------------------------------------- */

.btngacha {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.btngacha::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    transparent 30%,
    rgba(255, 255, 255, 0.9) 50%,
    transparent 70%,
    transparent 100%
  );
  animation: shine 2s infinite;
  z-index: 1;
  pointer-events: none;
}

.btngacha::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  animation: shine-delayed 2s infinite;
  animation-delay: 1s;
  z-index: 1;
  pointer-events: none;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@keyframes shine-delayed {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@media (min-width: 960px) {
  #app {
    height: 10%;
  }
  .pc_container {
    display: flex;
    margin-bottom: 10%;
  }
  .pc_movie_area {
    width: 50%;
    height: 80vh;
    background-color: #666;
  }
  .pc_info_area {
    width: 50%;
    height: 80vh;
    background-color: rgb(125, 125, 125);
    padding: 20px;
  }
  .pc_info_area_inner {
    position: relative;
    height: 100%;
  }
  .btn_sound {
    position: absolute;
    top: 0px;
    right: 15px;
    width: 40px;
    height: 40px;
    z-index: 1000;
    cursor: pointer;
    background-color: #3b3b3b;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
  }
  .pc_comment_list {
    height: calc(100% - 140px);
    overflow: scroll;
  }
  .pc_footer {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .pc_header {
    width: 100%;
    z-index: 2;
  }
  .pc_footer_inner {
    display: flex;
    flex-wrap: no-wrap;
    justify-content: space-between;
  }
  .pc_comment_area {
    width: 100%;
  }
  .footer {
    width: 100%;
    height: 40px;
    position: absolute;
    bottom: 5px;
    z-index: 1;
  }
}
</style>
